import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TaskItem } from '../../../home-data/models/submodels/task-item.model';
import { List } from 'immutable';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-home-tasks',
  templateUrl: './home-tasks.component.html',
  styleUrls: ['./home-tasks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTaskComponent implements OnInit {
  @Input() taskItems: List<TaskItem>;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  taskItemClick: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();
  @Output()
  taskItemDismiss: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();

  constructor() {}

  ngOnInit() {}
}
